// plugins/i18n-blog-switch.client.ts
export default defineNuxtPlugin(() => {
  if (process.server) {
    return { provide: { resolveBlogLocalePath: () => null } }
  }

  async function resolveBlogLocalePath(toLocale: string) {
    try {
      const route = useRoute()
      const { locale: currentLocale } = useI18n()
      const localePath = useLocalePath()
      const wp = useWordPress()

      const params = route.params as Record<string, any>
      const categorySlug = String(params.categorySlug || '')
      const slug = String(params.slug || '')
      const isPost = !!categorySlug && !!slug

      if (!isPost) return null

      console.log(`🔍 resolveBlogLocalePath: ${currentLocale.value} → ${toLocale}`)

      // Obtener post actual
      const currentPost = await wp.fetchPostBySlug(slug, currentLocale.value)
      if (!currentPost) return null

      // Obtener traducción por ID
      const targetId = currentPost.translations?.[toLocale]
      if (!targetId) return null

      const targetPost = await wp.fetchPostById(targetId, toLocale)
      if (!targetPost) return null

      // ✅ OBTENER CATEGORÍA TRADUCIDA
      const [currentCats, targetCats] = await Promise.all([
        wp.fetchCategories(currentLocale.value),
        wp.fetchCategories(toLocale)
      ])

      let targetCatSlug = categorySlug

      // Buscar categoría actual
      const currentCat = currentCats.find(c => String(c.slug) === String(categorySlug))
      if (currentCat) {
        // Buscar traducción
        const targetCatId = currentCat.translations?.[toLocale]
        if (targetCatId) {
          const targetCat = targetCats.find(c => Number(c.id) === Number(targetCatId))
          if (targetCat) targetCatSlug = targetCat.slug
        }
        
        // Fallback: categoría del post traducido
        if (targetCatSlug === categorySlug && targetPost.categories?.length) {
          const fallbackCat = targetCats.find(c => targetPost.categories.includes(c.id))
          if (fallbackCat) targetCatSlug = fallbackCat.slug
        }
      }

      const newPath = localePath(
        { 
          name: 'surfs-up-categorySlug-slug', 
          params: { 
            categorySlug: targetCatSlug, 
            slug: targetPost.slug 
          } 
        },
        toLocale
      )

      console.log(`✅ Resolved path with category: /${targetCatSlug}/${targetPost.slug}`)
      return newPath

    } catch (error) {
      console.error('❌ Error in resolveBlogLocalePath:', error)
      return null
    }
  }

  return { provide: { resolveBlogLocalePath } }
})